import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Media, MediaState } from "@penji/shared/data-access";

export const selectMediaState = createFeatureSelector<MediaState>('media_redux');

export const getMedia = (media_id:string) => createSelector(selectMediaState, mediaState => {
  return mediaState.entities[media_id] as Media;
})
